// jQuery is loaded synchronously via <script> tag in the layout (see master.blade.php)
// and exposed on window. Bundled modules import 'jquery' via the alias in
// vite.config.js which re-exports window.jQuery.
import 'bootstrap';

window.$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': window.$('meta[name="csrf-token"]').attr('content')
    }
});
